module.exports = __webpack_public_path__ + "assets/img/settings.07be1c86.svg";